import { Group, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

import env from '../app/env';

export const DevWarningBanner = () => {
    if (!env.IS_DEV) {
        return null;
    }

    return (
        <Group
            justify="center"
            gap={6}
            py={4}
            h={28}
            style={{
                backgroundImage:
                    'linear-gradient(-45deg, #e03131 25%, #c92a2a 25%, #c92a2a 50%, #e03131 50%, #e03131 75%, #c92a2a 75%)',
                backgroundSize: '28.28px 28.28px',
                backgroundPosition: 'center',
            }}
        >
            <IconAlertTriangle size={14} color="white" />
            <Text size="xs" c="white" fw={700} tt="uppercase" style={{ letterSpacing: '0.05em' }}>
                Development Environment
            </Text>
            <IconAlertTriangle size={14} color="white" />
        </Group>
    );
};
